export enum AccountLevel {
	General = 'general',
	Local = 'local',
	International = 'international',
	Representative = 'representative',
	Organizer = 'organizer',
	Workgroup = 'workgroup',
	Board = 'board',
	Dinosaur = 'dinosaur',
}